/**
 * @author Camilo
 * @since  19/11/2018
 */
export class RegistroNegocioPendienteModel{

    constructor(public negocio:string, public cantidad:number, public activarUsuario:boolean,public pendientesAprobacionContab:number){}

}

export class consultaIntefazNegocio{

    constructor(public interfaz:string, public fecha:string){}

}




// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/ConsultarInterfaz/RegistroNegocioPendiente.model.ts